<template>
  <div class="row justify-center">
    <loading-spinner v-if="checking" />
    <template v-else>
      <div
        class="card text-center px-1 py-2 m-auto"
        style="width:25rem;"
      >
        <img
          class="card-img-top py-3 px-5"
          src="@/assets/images/logo-aequaroma.jpg"
          alt="AEqua Roma"
        >
        <template v-if="!base">
          <div class="text-center my-2">Pannello di controllo per il portale Patrimonio Immobiliare di Roma Capitale</div>
          <div class="d-flex flex-column card-body">
            <template v-if="$store.getters.hasLocal">
              <h5 class="card-title text-uppercase">Accesso base</h5>
              <!--<p class="card-text">breve descrizione accesso base..</p> -->
              <p class="card-text"></p>
              <a
                href="https://www.aequaroma.it/pdf/condizioni_utilizzo_servizi_patrimonio.pdf"
                target="_blank"
              >
                Condizioni di utilizzo
              </a>.

              <b-button
                variant="primary"
                size="lg"
                @click="onAccessoBaseClick"
              >Accesso base</b-button>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="d-flex flex-column card-body align-middle">
            <b-input
              v-model="username"
              type="text"
              placeholder="Utente interno"
              class="m-1"
              autofocus
            />
            <b-input-group>
              <b-input
                v-model="password"
                :type="passwordFieldType"
                :formatter="formatTrim"
                placeholder="Password"
                class="m-1"
              />
              <b-input-group-append>
                <font-awesome-icon
                  :icon="fieldIcon"
                  size="lg"
                  class="text-primary cursor-pointer align-self-center"
                  @click="showPassword()"
                />
              </b-input-group-append>
            </b-input-group>
            <b-button
              variant="primary"
              size="lg"
              class="m-1"
              @click="onLoginClick"
            >Entra</b-button>
            <b-button
              variant="outline-secondary"
              size="lg"
              class="m-1"
              @click="onCancelClick"
            >Annulla l'accesso</b-button>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
// import SpidSmartButton from '@/components/SpidSmartButton'
// import { required } from 'vuelidate/lib/validators'

export default {

  components: {
    LoadingSpinner
  },

  data: () => {
    return {
      checking: true,
      base: false,
      username: '',
      password: '',
      passwordFieldType: 'password',
      fieldIcon: 'eye-slash'
    }
  },

  async beforeRouteEnter (to, from, next) {
    next(async (vm) => {
      // console.log('$store', vm.$store.getters.hasLocal, vm.$store.getters.hasSpid)
      try {
        await vm.$store.dispatch('info')
        // if (vm.$store.getters.isAuthenticated) vm.$router.push({ name: 'admin-panel' })
      } catch (err) {
        this.$ui.showError(err)
      }
      vm.checking = false
    })
  },

  methods: {
    onAccessoBaseClick () {
      this.base = true
    },
    onCancelClick () {
      this.base = false
    },
    async onLoginClick () {
      try {
        // if (this.validate()) {
        this.username = this.username.trim()
        this.password = this.password.trim()
        await this.$store.dispatch('loginAdmin', { username: this.username, password: this.password })
        // console.log('Dati utente: ', this.username, this)
        this.$router.push({ name: 'admin-panel' })
        // } else {
        //   this.$ui.notify({
        //     type: 'warning',
        //     title: 'Dati non corretti',
        //     message: 'Verificare le credenziali di accesso.'
        //   })
        // }
      } catch (err) {
        this.$ui.showError(err)
        // console.log('Accesso non consentito. Verificare le credenziali di accesso.', err)
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'Accesso non consentito. Verificare le credenziali di accesso.'
        })
      }
    },
    formatUcase (value, event) {
      return value.toUpperCase().trim()
    },
    formatTrim (value, event) {
      return value.trim()
    },
    validate () {
      this.$v.username.$touch()

      return !this.$v.username.$invalid
    },
    showPassword () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
        this.fieldIcon = 'eye'
      } else {
        this.passwordFieldType = 'password'
        this.fieldIcon = 'eye-slash'
      }
    }

  }

}
</script>

<style lang="stylus" scoped></style>
